/* eslint-disable */
import { memo, forwardRef } from "react";

// bar.tsx
export const BarIcon = memo(
  forwardRef(function BarIcon(
    { size = 24, color = "currentColor", title, className },
    ref,
  ) {
    return (
      <svg
        viewBox="0 0 26 26"
        ref={ref}
        width={size}
        height={size}
        fill={color}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        // role={title ? "img" : "presentation"}
        focusable="false"
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M23.1055 6.70312C22.8516 5.80599 22.3776 5.04427 21.6836 4.41797C20.9896 3.79167 20.1855 3.40234 19.2715 3.25H19.2461C19.1445 3.23307 19.0303 3.22038 18.9033 3.21191C18.7764 3.20345 18.6452 3.19922 18.5098 3.19922C18.1543 3.19922 17.8115 3.23307 17.4814 3.30078C17.1514 3.36849 16.834 3.47852 16.5293 3.63086L16.5547 3.60547C15.8268 3.94401 15.2174 4.43913 14.7266 5.09082C14.2357 5.74251 13.931 6.47461 13.8125 7.28711V7.3125H2.7168L11.2734 17.1895V21.6074H8.17578V22.8262H15.5898V21.6074H12.5176V17.2148L17.1895 11.8828L21.125 7.3125H15.0059C15.0566 7.05859 15.1243 6.82162 15.209 6.60156C15.2936 6.38151 15.4036 6.16992 15.5391 5.9668V5.99219C15.8607 5.5013 16.2839 5.10775 16.8086 4.81152C17.3333 4.5153 17.9004 4.36719 18.5098 4.36719C18.6113 4.36719 18.7087 4.37142 18.8018 4.37988C18.8949 4.38835 18.9922 4.40104 19.0938 4.41797H19.0684C19.4238 4.46875 19.7539 4.57031 20.0586 4.72266C20.3633 4.875 20.6341 5.0612 20.8711 5.28125C21.125 5.5013 21.3408 5.75944 21.5186 6.05566C21.6963 6.35189 21.8359 6.66081 21.9375 6.98242V7.00781C21.9714 7.16016 22.001 7.3125 22.0264 7.46484C22.0518 7.61719 22.0645 7.778 22.0645 7.94727C22.0645 8.48893 21.946 9.00098 21.709 9.4834C21.472 9.96582 21.1589 10.3678 20.7695 10.6895H20.7441C20.4902 10.9095 20.2109 11.0915 19.9062 11.2354C19.6016 11.3792 19.2715 11.4681 18.916 11.502H18.8906L19.0176 12.7207C19.9655 12.6191 20.7992 12.2721 21.5186 11.6797C22.238 11.0872 22.7415 10.3594 23.0293 9.49609L23.0547 9.4707C23.1224 9.25065 23.1774 9.01367 23.2197 8.75977C23.262 8.50586 23.2832 8.25195 23.2832 7.99805C23.2832 7.76107 23.2663 7.53255 23.2324 7.3125C23.1986 7.09245 23.1562 6.8724 23.1055 6.65234V6.70312ZM11.9082 16.0723L8.42969 12.0859H15.3867L11.9082 16.0723ZM16.4531 10.8672H7.38867L5.38281 8.55664H18.459L16.4531 10.8672Z"
          fill={color}
        />
      </svg>
    );
  }),
);
